import { Navigate, Outlet } from "react-router-dom";
import Cookies from "js-cookie";
import { decode as base64_decode } from "base-64";
const ProtectedRoute = ({ path, children }) => {
  //let cookies = Cookies.get("data");
  //let data = JSON.parse(base64_decode(cookies));
  const rolePermission2 = JSON.parse(localStorage.getItem("rolePermission2"));
  //data.rolePermission = JSON.parse(localStorage.getItem('rolePermission'));


  if (rolePermission2[path]?.canView !== 1) {

    return <Navigate to={"/lounchingDashboard"} replace />;
  }
  return children ? children : <Outlet />;
};
export default ProtectedRoute;
